import { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext({});

export function useApp() {
    return useContext(AppContext);
}

export function AppProvider({ children }) {
    const [appType, setAppType] = useState();
    const [mode, setMode] = useState();
    const [kioskHeader, setKioskHeader] = useState(null);
    const [student, setStudent] = useState(null);
    const [initialRedirectDone, setInitialRedirectDone] = useState(false);
    const [appState, setAppState] = useState({});

    const AddState = (key, value) => {
        setAppState(prevState => ({ ...prevState, [key]: value }));
    }


    useEffect(() => {
        //Load values from storage
        let storedValue = null;
        storedValue = sessionStorage.getItem("kiosk_app_type");
        if(storedValue != null)
            setAppType(storedValue);

        storedValue = sessionStorage.getItem("kiosk_mode");
        if(storedValue != null)
            setMode(storedValue);

        storedValue = sessionStorage.getItem("kiosk_header");
        if(storedValue != null)
            setKioskHeader(storedValue);

        storedValue = sessionStorage.getItem("kiosk_redirect_done");
        if(storedValue != null)
            setInitialRedirectDone(storedValue);

    },[])

    const storage = (key, func) => (value) => {
        //Update session storage
        sessionStorage.setItem(key, value);
        //Update components state
        if (typeof func === 'function'){
            func(value)
        }
    }

    const value = {
        appType, 
        setAppType: storage("kiosk_app_type",setAppType),
        mode,
        setMode: storage("kiosk_mode",setMode),
        student, 
        setStudent,
        kioskHeader, 
        setKioskHeader: storage("kiosk_header",setKioskHeader),
        initialRedirectDone, 
        setInitialRedirectDone: storage("kiosk_redirect_done",setInitialRedirectDone),
        appState,
        AddState
    }

    return <AppContext.Provider value={value}>
        {children}
    </AppContext.Provider> 
}